// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","logo":"Footer_logo__w79hm"};